import React from "react";
import "./summercampsblock2.css"; // if you have styling

const SummerCampsBlock2 = ({
  image,
  name1,
  description1,
  name2,
  description2,
  order,
}) => {
  return (
    <div className={`summercampsblock-ss-block-ui ${order}`}>
      {/* Image */}
      <div className="ssb-img">
        {/* <img src={image} alt={name} /> */}
        <img src={image} title={name1} />
      </div>

      {/* Content */}
      <div className="ssb-cnt">
        <div className="ssb-title">
          <h2 className="text-clip">{name1}</h2>
        </div>

        <div className="ssb-desc">
          <p className="text-clip" style={{ marginBottom: "20px" }}>
            {description1}
          </p>
        </div>
        <hr />

        <div className="ssb-title">
          <h2 className="text-clip">{name2}</h2>
        </div>

        <div className="ssb-desc">
          <p className="text-clip" style={{ marginBottom: "20px" }}>
            {description2}
          </p>
        </div>
      </div>
    </div>
  );
};

export default SummerCampsBlock2;
